import { UpsellEmailVariantEnum } from '@app/services/api/api.types';

export type TripUpsellBannerCopy = {
  title: string;
  body: string;
  globeSrc: string;
};

export const TRIP_UPSELL_BANNER_COPY: Record<
  UpsellEmailVariantEnum.EMAIL1 | UpsellEmailVariantEnum.EMAIL2,
  TripUpsellBannerCopy
> = {
  [UpsellEmailVariantEnum.EMAIL1]: {
    title: 'Avoid extra costs with Essential Plan',
    body: 'Unexpected changes can lead to extra fees or expensive rebooking. Essential Plan helps you avoid paying more if plans change',
    globeSrc: 'assets/images/earth.svg',
  },
  [UpsellEmailVariantEnum.EMAIL2]: {
    title: 'Get stronger protection with VIP Plan',
    body: 'Unexpected disruptions can result in costly rebooking or lost flights. VIP Plan offers higher coverage and more comprehensive protection',
    globeSrc: 'assets/images/earth.svg',
  },
};

export const TRIP_UPSELL_BANNER_EXPIRED_COPY = {
  title: 'Plan upgrade is no longer available for this trip',
  body: 'The option to upgrade your plan for this trip was available for a limited time after booking.',
};
